import { HttpContextToken } from '@angular/common/http';

/**
 * Set on requests to third-party endpoints (e.g. the N8N Vera webhook) so
 * JwtInterceptor skips attaching the internal Firebase Bearer token to them.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
